const WORDS = ["Plant the seed and feed the people", "Manage. Monitor. Grow.", "Healthy Farms. Healthy People.", "From Farm to Future", "Stronger Together"];

export const Marquee = () => (
  <div className="py-12 border-y border-[rgba(111,227,155,0.16)] overflow-hidden bg-[color:var(--kmg-deep)]" data-testid="marquee">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0">
          {WORDS.map((w, i) => (
            <span key={`${dup}-${w}`} className="flex items-center">
              <span
                className={`font-display text-2xl sm:text-4xl px-8 whitespace-nowrap ${
                  i % 2 === 0 ? "outline-type" : "text-[color:var(--kmg-bone)]"
                }`}
              >
                {w}
              </span>
              <span className="text-[color:var(--kmg-gold)] text-xl">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
